// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_21tDy","gotoTop":"_3ZVXL"};